import React, { Fragment, Suspense, useEffect, useState } from 'react';
import { constants } from '../../Constants';
import Slider from "react-slick";
import '../scss/Home.scss';
import "../scss/Menu.scss";
import {
    BrowserView,
    MobileView
} from "react-device-detect";
import spinner from "../../images/spinner.gif";
import moment from "moment";

const Header = React.lazy(() => import("../common/Header"));
const Footer = React.lazy(() => import("../common/Footer"));
const MenuComponent = React.lazy(() => import("./MenuComponent"));
const CustomizedModal = React.lazy(() => import("./CustomizedModal"));
const Popup = React.lazy(() => import("../common/Popup"));


function checkProduct(findKeyValue, myArray) {
    if (myArray && myArray.length > 0) {
        for (var i = 0; i < myArray.length; i++) {
            if (myArray[i].product_id === findKeyValue) {
                return myArray[i];
            }
        }
    }
}

export default function Home(props) {
    const [isVeg, setIsVeg] = useState(false);
    const [sliderData, setSliderData] = useState([]);
    const [menuData, setMenuData] = useState();
    const [addToCartProduct, setAddToCartProduct] = useState(null);
    const [customizedData, setCustomizedData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isUserApiAddress, setUserApiAddress] = useState(null);
    const [showPopup, setShowPopup] = useState("");
    const [sliderSetting, setSliderSetting] = useState({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        speed: 2500,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true
    });
    const [sliderLoading, setSliderLoading] = useState(false);
    const [previousOrder, setPreviousOrder] = useState("");

    useEffect(() => {

        async function getLatestOrder() {
            const module = await import("../api");
            let myOrders = await module.myOrders(1, 1);

            if (myOrders && myOrders.status) {
                myOrders = myOrders.result.data && myOrders.result.data.length > 0 ? myOrders.result.data[0] : "";
                setPreviousOrder(myOrders);
            }
        }

        getLatestOrder();

    }, []);

    const toggleVeg = (e) => {
        setIsVeg(!isVeg);
        window.setCookie("isVeg", !isVeg);
        window.$(".bn-toggle").toggleClass("active");
        window.$(".handle").toggleClass("active");
    }

    const redirectWithMenu = (menu) => {
        var checkDiv = setInterval(function () {
            if (window.$("#" + menu).length > 0) {
                clearInterval(checkDiv);
                window.$('html, body').animate({
                    scrollTop: window.$("#" + menu).offset().top - 80
                }, 500);
                window.$("#" + menu).addClass("active");
                window.$("#" + menu).next(".memulistbody").css("display", "block");
            }
        }, 100);
    }

    useEffect(() => {
        async function fetchSlider() {
            const module = await import("../api");
            let sliderData = await module.getSliderList();
            if (sliderData.status) {
                setSliderData(sliderData.result);
                fetchMenu();

                if (props.history.location.state) {
                    setIsLoading(false);
                }
            } else {
                window.createNotification("error", "Not able to load data please reload the site");
            }
        }
        fetchSlider();
    }, [props.history.location.state]);

    const fetchMenu = async () => {
        const module = await import("../api");
        let menuData = await module.getMenuList();
        if (menuData.status) {
            setMenuData(menuData.result);
        } else {
            window.createNotification("error", "Not able to load data please reload the site");
        }
    }

    const showCustomizedModal = (products) => {
        setSliderSetting({
            ...sliderSetting,
            autoplay: false
        })
        setCustomizedData(products);
        setShowModal(!showModal);
    }

    const addTocart = async (product) => {
        // if(addToCartProduct && addToCartProduct.offer_id) {
        //     window.createNotification("error", "You have an active coupon applied, to apply coupon on all item please remove and apply again.");
        // }
        setSliderSetting({
            ...sliderSetting,
            autoplay: false
        })
        if (window.$(".add-button-" + product.id)) {
            window.$(".add-button-" + product.id).find(".loader-icon").show();
            window.$(".add-button-" + product.id).find(".qty-toggle").hide();
            window.$(".add-button-" + product.id).find("a").attr("data-disabled", "true");
            window.$(".add-button-" + product.id).find(".fa-spin").show();
        }

        let apiProduct = {
            product_id: product.id,
            qty: product.qty || 1,
            price: product.price,
            product_name: product.name,
            is_customized: product.is_customizable,
            convenience_fee: 0,
            delivery_charge: 0,
        }

        if (product.remove_item) {
            apiProduct.remove_item = product.remove_item;
        }

        if (product.is_customizable) {
            apiProduct.new_customize_data = product.new_customize_data;
        }

        try {
            const module = await import("../api");
            const addToCartResponse = await module.addToCartApi(apiProduct);
            if (addToCartResponse.data.status) {
                setCustomizedData("");
                setShowModal(false);
                window.$('.customizebox').removeClass('slide');
                window.$('.customItem').prop('checked', false);
                if (addToCartResponse.data.message === "popup") {
                    setShowPopup(addToCartResponse.data.result.response_msg);
                } else {
                    if (product.increase) {
                        var cart = window.$("#animate-cart");
                        var imgtodrag = window.$("#img_" + product.id).eq(0);
                        if (imgtodrag) {
                            window.addToCartAnimation(imgtodrag, cart);
                        }
                    }

                    if (addToCartResponse.data.result) {
                        window.setCookie("token", addToCartResponse.data.result.token);
                    }
                    setShowModal(!showModal);
                    const getCartData = await module.getCartItem();
                    if (getCartData.data.status) {
                        setAddToCartProduct(getCartData.data.result);

                        if (getCartData.data.result) {
                            window.$(".cartclick").css("opacity", "1");
                            window.$(".menuflex span").addClass("counter");
                            window.$(".menuflex span").html(getCartData.data.result.items_qty);
                            window.$(".cartclick h4").text("View Cart");
                        } else {
                            window.$(".cartclick").css("opacity", "0.8");
                            window.$(".menuflex span").removeClass("counter");
                            window.$(".menuflex span").html("");
                            window.$(".cartclick h4").text("Cart");
                        }

                        if (getCartData.data.result && getCartData.data.result.offer_id) {
                            if (addToCartResponse.data.message === "You have an active coupon applied which is applicable for this product. Please remove and apply again")
                                window.createNotification("error", addToCartResponse.data.message);
                        }
                        if (addToCartResponse.data.message === "popup") {
                            setShowPopup(addToCartResponse.data.result.response_msg);
                        }
                    }
                }
                if (window.$(".add-button-" + product.id)) {
                    window.$(".add-button-" + product.id).find(".loader-icon").hide();
                    window.$(".add-button-" + product.id).find(".qty-toggle").show();
                    window.$(".add-button-" + product.id).find("a").attr("data-disabled", "false");
                    window.$(".add-button-" + product.id).find(".fa-spin").hide();
                }
            } else {
                window.createNotification("error", addToCartResponse.data.message);
                if (window.$(".add-button-" + product.id)) {
                    window.$(".add-button-" + product.id).find(".loader-icon").hide();
                    window.$(".add-button-" + product.id).find(".qty-toggle").show();
                    window.$(".add-button-" + product.id).find("a").attr("data-disabled", "false");
                    window.$(".add-button-" + product.id).find(".fa-spin").hide();
                }
            }
        } catch (error) {
            window.createNotification("error", error);
        }
        setSliderSetting({
            ...sliderSetting,
            autoplay: true
        })
        setIsLoading(false);
    }

    const handleCustomizedModal = () => {
        window.$(".addanchor").attr("data-disabled", "false");
        window.$(".addanchor").find("i").hide();
        setShowModal(false);
        setCustomizedData(null);
        setSliderSetting({
            ...sliderSetting,
            autoplay: true
        });
    }

    const showLoader = (event, data) => {
        if (window.$(event.target).attr("data-disabled") === 'false') {
            window.$(event.target).find("i").show();
            window.$(event.target).attr("data-disabled", "true");
            if (data.is_customizable) {
                showCustomizedModal(data);
            } else {
                addTocart(data);
            }
        }
        return false;
    }

    const sliderImagesLoaded = () => {
        setSliderLoading(false);
    }

    let menuImageCounter = 0;
    const menuImageLoaded = async () => {
        setIsLoading(false);
        menuImageCounter += 1;
        if (menuImageCounter === menuData.length) {
            const module = await import("../api");
            const fetchedData = await module.getCartItem();
            if (fetchedData.data && fetchedData.data.status) {
                setAddToCartProduct(fetchedData.data.result);

                let userAddressRes = await module.getUserAddress();
                if (userAddressRes && userAddressRes.data && userAddressRes.data.status && userAddressRes.data.result) {
                    setUserApiAddress(userAddressRes.data.result[0]);
                }
            }
        }
    }

    const repeatOrders = async (data) => {
        window.$(".repeat-spin").show();

        const module = await import("../api");
        let res = await module.repeatOrder(data.id);

        if (res) {
            if (res.status) {
                window.createNotification("success", res.message);
                window.$(".repeat-spin").hide();
                const getCartData = await module.getCartItem();
                if (getCartData.data.status) {
                    setAddToCartProduct(getCartData.data.result);
                }
            } else {
                window.createNotification("error", res.message);
            }
        } else {
            window.createNotification("error", "Something went wrong");
        }
    }

    return (
        <div className="wrapper">
            <Suspense fallback={<div></div>}>
                <Header props={props} />
            </Suspense>
            {
                sliderLoading
                    ?
                    <div className="loader-default"><img src={spinner} alt="Loading" className="loader-spinner" /></div>
                    :
                    null
            }

            {
                sliderData
                    ?
                    <Fragment>
                        <section className="banner-section">
                            <div className="container-fluid">
                                <Slider {...sliderSetting}>
                                    {
                                        sliderData.map(function (bannerData, bannerKey) {
                                            var isAdded = checkProduct(bannerData.id, addToCartProduct ? addToCartProduct.carts_items : []);
                                            return (
                                                <div className="bannerslide" key={bannerKey}>
                                                    <div className={"bannerimg banner-button-" + bannerData.id}>
                                                        <BrowserView>
                                                            <img src={constants.IMAGE_URL + bannerData.desktop_banner} alt="Thumbnail" className="mainbannerimg" id={"img_" + bannerData.id} onLoad={() => sliderImagesLoaded(bannerKey)} />
                                                        </BrowserView>
                                                        <MobileView>
                                                            <img src={constants.IMAGE_URL + bannerData.banner} alt="Thumbnail" className="mainbannerimg" id={"img_" + bannerData.id} onLoad={() => sliderImagesLoaded(bannerKey)} />
                                                        </MobileView>
                                                        {
                                                            bannerData.menu_id
                                                                ?
                                                                <button name="button" onClick={(e) => { e.preventDefault(); redirectWithMenu("menu_" + bannerData.menu_id) }} className="addanchor">Go &nbsp; <i className="fa fa-arrow-down"></i></button>
                                                                :
                                                                isAdded || (!bannerData.isCartAvailable)
                                                                    ?
                                                                    null
                                                                    :
                                                                    bannerData.is_customizable
                                                                        ?
                                                                        <button name="button" data-disabled="false" onClick={(e) => { showLoader(e, bannerData); }} className="addanchor">Add to Cart <i style={{ display: "none" }} className="fa fa-spinner fa-spin"></i></button>
                                                                        :
                                                                        <button name="button" data-disabled="false" onClick={(e) => { showLoader(e, bannerData); }} className="addanchor">Add to Cart <i style={{ display: "none" }} className="fa fa-spinner fa-spin"></i></button>
                                                        }
                                                    </div>
                                                    {
                                                        isAdded
                                                            ?
                                                            <div className="offertimer">
                                                                <i className="fa fa-check" style={{ color: "#04b804", padding: "10px" }}></i>
                                                                <h4>Added to Cart</h4>
                                                            </div>
                                                            :
                                                            <div className="offertimer">
                                                                <img src="https://api2.nirulas.com/nirulas-api/public/assets/images/hourglass.png" alt="Hour" />
                                                                <h4>Deal Ends in  <span className="countdown"></span></h4>
                                                            </div>
                                                    }
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </section>
                        {
                            menuData && !sliderLoading
                                ?
                                <section className="menulist-section">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="menulist-inner">
                                                    <div className="menulist-header" style={isUserApiAddress && isUserApiAddress.name ? { justifyContent: "space-between" } : { justifyContent: "flex-end" }}>
                                                        {
                                                            isUserApiAddress && isUserApiAddress.name
                                                                ?
                                                                <h3>Hi {isUserApiAddress.name.split(" ")[0]}!</h3>
                                                                :
                                                                null
                                                        }
                                                        <div className="filtervegnonbeg">
                                                            <h5>Veg Only</h5>
                                                            <button type="button" className={window.getCookie("isVeg") && window.getCookie("isVeg") === "true" ? "btn btn-sm btn-secondary bn-toggle filbtn active" : "btn btn-sm btn-secondary bn-toggle filbtn"} onClick={(e) => toggleVeg(e)}>
                                                                <div className="handle"></div>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {
                                                        previousOrder
                                                            ?
                                                            <div className="orderbox">
                                                                <a href="/" onClick={(e) => { window.$(".orderbox").hide(500); e.preventDefault(); }}>
                                                                    <div className="closeorder">
                                                                        <img src="https://api2.nirulas.com/nirulas-api/public/assets/images/close.png" alt="Close" />
                                                                    </div>
                                                                </a>
                                                                <h4><strong>Previous Order</strong> </h4>
                                                                <div className="topflexxbox">
                                                                    <h5> Order Total: <strong> <i className="fa fa-inr"> </i> {previousOrder.grand_total}/-</strong> </h5>
                                                                    <h5> Ordered on : {moment(previousOrder.created).format("DD/MM/Y")}</h5>
                                                                </div>
                                                                <h5 className="mh-7 h5tag">
                                                                    Items:
                                                                    {
                                                                        previousOrder.orders_items && previousOrder.orders_items.length > 0
                                                                            ?
                                                                            <ul className="order-product">
                                                                                {
                                                                                    previousOrder.orders_items.map(function (itemData, itemKey) {
                                                                                        return (
                                                                                            <li key={itemKey}>
                                                                                                <BrowserView>
                                                                                                    {itemData.product_name}
                                                                                                </BrowserView>
                                                                                                <MobileView>
                                                                                                    {itemData.product_name.substring(0, 140) + '...'}
                                                                                                </MobileView>
                                                                                            </li>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </ul>
                                                                            :
                                                                            null
                                                                    }
                                                                </h5>
                                                                {
                                                                    window.$(".h5tag").text().length > 500
                                                                        ?
                                                                        <p onClick={(e) => { window.$(e.target).prev("h5").toggleClass("mh-7", 500); window.$(e.target).text(window.$(e.target).text() === "More" ? "Less" : "More") }}>More</p>
                                                                        :
                                                                        null
                                                                }
                                                                <div className="bottombox">
                                                                    <div className="orderidbox">
                                                                        <h4> Order No.: <span> {previousOrder.order_number}</span> </h4>
                                                                    </div>
                                                                    <div className="orderaction">
                                                                        {/* <a className="repeatclick" href="/" onClick={(e) => { window.$(".repeat-spin").show(); repeatOrders(previousOrder); e.preventDefault(); }} >
                                                                            REPEAT
                                                                            <i style={{ display: "none" }} className="fa fa-spinner repeat-spin fa-spin"></i>
                                                                        </a> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }

                                                    <div className="row menu-row">
                                                        {
                                                            menuData.map(function (menuRow, menuKey) {
                                                                return (
                                                                    <div className="col-md-4" key={menuKey}>
                                                                        <div className="menubox" onClick={() => redirectWithMenu("menu_" + menuRow.id)}>
                                                                            <div className="menu-thumb">
                                                                                <img
                                                                                    alt={menuRow.title}
                                                                                    effect="blur"
                                                                                    src={constants.IMAGE_URL + menuRow.thumbnail}
                                                                                    width="100%"
                                                                                    onLoad={() => menuImageLoaded(menuKey)} />
                                                                                {/* <img src={menuRow.thumbnail} width="100%" /> */}
                                                                            </div>
                                                                            <label dangerouslySetInnerHTML={{ __html: menuRow.title }}></label>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        isLoading && !addToCartProduct
                                                            ?
                                                            <div className="text-center">
                                                                <h2>Loading ...</h2>
                                                            </div>
                                                            :
                                                            <Suspense fallback={<div></div>}>
                                                                <MenuComponent props={props} isVeg={isVeg} toogleVegFilter={(e) => toggleVeg(e)} fetchedDataProps={addToCartProduct} addTocart={(product) => addTocart(product)} showCustomizedModal={(product) => showCustomizedModal(product)} handleCustomizedModal={() => handleCustomizedModal()} />
                                                            </Suspense>
                                                    }
                                                    {
                                                        customizedData
                                                            ?
                                                            <Suspense fallback={<div></div>}>
                                                                <CustomizedModal addTocart={(product) => addTocart(product)} customizedData={customizedData} show={showModal} closeModal={() => handleCustomizedModal()} isVeg={props.isVeg} />
                                                            </Suspense>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                :
                                <div className="text-center">
                                    <h2>Loading ...</h2>
                                </div>
                        }
                    </Fragment>
                    :
                    null
            }

            {
                showPopup
                    ?
                    <Suspense fallback={<div></div>}>
                        <Popup msg={showPopup} show={showPopup ? true : false} closeModal={() => setShowPopup("")} />
                    </Suspense>
                    :
                    null
            }
            <Suspense fallback={<div></div>}>
                <Footer cartCount={addToCartProduct} />
            </Suspense>
        </div >
    )

}